"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OD_VOUCHER_ORIGIN = exports.REPUDIATION_CODES = exports.DEFAULT_PROMOTIONNAL_CODE = exports.WeekDay = exports.TimeSlot = exports.HousingType = void 0;
var HousingType;
(function (HousingType) {
    HousingType["HOUSE"] = "house";
    HousingType["FLAT"] = "flat";
})(HousingType = exports.HousingType || (exports.HousingType = {}));
var TimeSlot;
(function (TimeSlot) {
    TimeSlot["AM"] = "am";
    TimeSlot["PM"] = "pm";
    TimeSlot["EVENING"] = "evening";
})(TimeSlot = exports.TimeSlot || (exports.TimeSlot = {}));
var WeekDay;
(function (WeekDay) {
    WeekDay[WeekDay["Sunday"] = 0] = "Sunday";
    WeekDay[WeekDay["Monday"] = 1] = "Monday";
    WeekDay[WeekDay["Tuesday"] = 2] = "Tuesday";
    WeekDay[WeekDay["Wednesday"] = 3] = "Wednesday";
    WeekDay[WeekDay["Thursday"] = 4] = "Thursday";
    WeekDay[WeekDay["Friday"] = 5] = "Friday";
    WeekDay[WeekDay["Saturday"] = 6] = "Saturday";
})(WeekDay = exports.WeekDay || (exports.WeekDay = {}));
exports.DEFAULT_PROMOTIONNAL_CODE = 'CLIENTPROMO';
exports.REPUDIATION_CODES = [exports.DEFAULT_PROMOTIONNAL_CODE, 'CLIENTPROMO20', 'CLIENTPROMO49'];
exports.OD_VOUCHER_ORIGIN = 'onDemand';
//# sourceMappingURL=common.js.map